<div *ngIf="!isEditing && clickToEdit" (click)="startEditing()" class="click-to-edit-area">
    <span *ngIf="initialValue">
        <span *ngIf="nzShowTime">{{ initialValue | date: "YYYY-MM-dd HH:mm:ss" }}</span>
        <span *ngIf="!nzShowTime">{{ initialValue | date: "YYYY-MM-dd" }}</span>
    </span>
    <span *ngIf="!initialValue">--</span>
</div>

<div *ngIf="isEditing || !clickToEdit">
    <nz-date-picker
        #datePickerComponent
        [nzShowTime]="nzShowTime"
        [nzFormat]="nzShowTime ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd'"
        [(ngModel)]="currentValue"
        style="width: 100%"
        [nzDisabledDate]="disabledDate"
        (ngModelChange)="changeValue()"
        (nzOnOpenChange)="openChange($event)"
    ></nz-date-picker>
</div>
